module.exports = __webpack_public_path__ + "img/invite-img@2x.1ad44baf.png";